__turbopack_context__.v({
  "Active": "Menu-module__6o23Sq__Active",
  "Menu": "Menu-module__6o23Sq__Menu",
  "MenuClose": "Menu-module__6o23Sq__MenuClose",
  "MenuCloseIcon": "Menu-module__6o23Sq__MenuCloseIcon",
  "MenuContent": "Menu-module__6o23Sq__MenuContent",
});
